import { Component, Input, AfterViewInit } from '@angular/core';

declare var $: any;

@Component({
    selector: 'itpx-pagebase',
    templateUrl: './component.html',
    styleUrls: [ './component.css' ]
})
export class PageBaseComponent implements AfterViewInit {
    @Input() status: string;
    @Input() errorMessage: string;
    @Input() errorTitle: string;
    @Input() message: string;

    constructor(
    ) {}

    ngAfterViewInit() {
        // $(function () {
        //     $('#page-base-scroller').slimScroll({
        //         height: '100%',
        //         width: '100%'
        //     });
        // });
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/partials/pagebase/component.ts